import React, { Component } from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import {
  LineChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Line,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

import KarteStore from '../../store';
import { PopulationDataType, ValueType, SheetFormat } from '../../types';

type Props = {
  karteStore: KarteStore;
  karteIndex: number;
};

type LabelProps = {
  x?: number;
  y?: number;
  stroke?: string;
  value?: number | undefined;
};
const CustomizedLabel: React.FC<LabelProps> = ({ x, y, stroke, value }) => {
  return (
    <text
      x={x}
      y={y}
      dy={-4}
      fill={stroke}
      fontSize={9}
      textAnchor="middle"
      letterSpacing={-0.5}
    >
      {value}
    </text>
  );
};

@observer
class LineChartForKarte extends Component<Props> {
  render() {
    const { karteIndex, karteStore } = this.props;
    const { karte, data } = karteStore.getChartData(karteIndex);

    if (!data) return null;

    return (
      <Wrapper>
        <ChartTitle>
          <span
            style={{
              fontWeight:
                karteStore.sheetFormat === SheetFormat.Template ? 900 : 100
            }}
          >
            {karte.area}
          </span>
          の{karte.populationDataType}
          {karte.populationDataType === PopulationDataType.Support && (
            <>（{karte.support}）</>
          )}
          {karte.valueType === ValueType.Amount
            ? 'の推移'
            : '（1999年を100とした場合）'}
        </ChartTitle>
        <ChartWrapper>
          <ResponsiveContainer width="94%" height="94%">
            <LineChart data={data}>
              <XAxis dataKey="year" />
              <YAxis />
              <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
              <Tooltip />
              {karte.valueType === ValueType.Proportion && (
                <Legend verticalAlign="top" height={36} />
              )}
              {data[0] &&
                Object.keys(data[0]).map((k, i) =>
                  k === 'year' ? null : (
                    <Line
                      type="monotone"
                      key={k}
                      dataKey={k}
                      stroke={this.strokeColor(i)}
                      isAnimationActive={false}
                      label={i === 1 ? <CustomizedLabel /> : undefined}
                      strokeDasharray={this.strokeDashArray(i)}
                    />
                  )
                )}
            </LineChart>
          </ResponsiveContainer>
        </ChartWrapper>
      </Wrapper>
    );
  }

  strokeDashArray(index: number): string {
    switch (index) {
      case 1:
        return '';
      case 2:
        return '5 5';
      case 3:
        return '1 1';
      default:
        return '';
    }
  }

  strokeColor(index: number): string {
    switch (index) {
      case 1:
        return '#520018';
      case 2:
        return '#D1172D';
      case 3:
        return '#FFA526';
      default:
        return '#800026';
    }
  }
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  background: white;
  display: flex;
  flex-direction: column;
`;

const ChartTitle = styled.div`
  text-align: center;
  font-size: 18px;
  margin: 10px 0 10px 50px;
`;

const ChartWrapper = styled.div`
  width: 100%;
  flex: 1;
`;

export default LineChartForKarte;
